import UpdateInventoryTypeContent from "../../content/inventoryType/updateInventoryType";
import { Layout } from "../../layout/page";

export function UpdatedInventoryTypeInput() {
  return (
    <Layout>
      <UpdateInventoryTypeContent />
    </Layout>
  );
}
